module.exports = __webpack_public_path__ + "img/B-4.a3078279.png";